import { Injectable } from '@angular/core';
import { Variables } from '../../utils/variables';
import { HelperFunctions } from '../../utils/helper.functions';
import { AuthenticatedUser, Token } from '../../models/auth.models';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  static setAuthenticatedUser(user: AuthenticatedUser): void {
    localStorage.setItem(Variables.STORAGE.AUTH_USER, HelperFunctions.encryptAny(user));
  }

  static get getAuthenticatedUser(): AuthenticatedUser | null {
    const user = localStorage.getItem(Variables.STORAGE.AUTH_USER);

    return user ? HelperFunctions.decryptAny(user) : null;
  }

  static set setAuthToken(token: Token) {
    localStorage.setItem(Variables.STORAGE.AUTH_TOKEN, HelperFunctions.encryptAny(token));
  }

  static get getAuthToken(): Token | null {
    const token = localStorage.getItem(Variables.STORAGE.AUTH_TOKEN);

    return token ? HelperFunctions.decryptAny(token) : null;
  }

  static clearAuthToken(): void {
    localStorage.removeItem(Variables.STORAGE.AUTH_TOKEN);
  }

  static clearAuthenticatedUser(): void {
    localStorage.removeItem(Variables.STORAGE.AUTH_USER);
  }
}
